(function () {
  const QUOTE_MESSAGE_PREFIX =
    "Hola Industrial Magza Me gustaría obtener presupuesto sobre el siguiente producto ";

  function buildQuoteMessage(productUrl) {
    return `${QUOTE_MESSAGE_PREFIX}${productUrl}`;
  }

  function prefillChatwootComposer(message) {
    if (!window.$chatwoot) {
      return;
    }

    if (typeof window.$chatwoot.setConversationCustomAttributes === "function") {
      window.$chatwoot.setConversationCustomAttributes({
        quote_request: "true",
        product_url: message.replace(QUOTE_MESSAGE_PREFIX, ""),
      });
    }

    const iframe = document.getElementById("chatwoot_live_chat_widget");
    if (!iframe) {
      return;
    }

    try {
      const textarea = iframe.contentDocument?.querySelector("textarea");
      if (textarea) {
        textarea.value = message;
        textarea.dispatchEvent(new Event("input", { bubbles: true }));
        return;
      }
    } catch (error) {
      // Cross-origin iframe access may be blocked; fall back to postMessage below.
    }

    iframe.contentWindow?.postMessage(
      `chatwoot-widget:${JSON.stringify({ event: "prefill-message", message })}`,
      "*",
    );
  }

  function schedulePrefill(message) {
    [300, 700, 1200, 2000].forEach((delay) => {
      window.setTimeout(() => prefillChatwootComposer(message), delay);
    });
  }

  function openChatwootWithMessage(message) {
    window.__pendingChatwootQuoteMessage = message;

    const openAndPrefill = () => {
      if (window.ChatwootLauncher?.open) {
        window.ChatwootLauncher.open();
      } else if (window.$chatwoot) {
        window.$chatwoot.toggle("open");
      }

      schedulePrefill(message);
    };

    if (window.$chatwoot) {
      openAndPrefill();
      return;
    }

    document.addEventListener("chatwoot:ready", openAndPrefill, { once: true });
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest(".button-request-quote");
    if (!button) {
      return;
    }

    event.preventDefault();

    const productUrl = button.dataset.productUrl || window.location.href.split("#")[0];
    openChatwootWithMessage(buildQuoteMessage(productUrl));
  });

  document.addEventListener("chatwoot:ready", () => {
    if (!window.__pendingChatwootQuoteMessage) {
      return;
    }

    prefillChatwootComposer(window.__pendingChatwootQuoteMessage);
  });
})();
